module.exports = __webpack_public_path__ + "static/Larsseit-Bold-51276a108406733671240b5b8d813b12.otf";